<template>
<v-container id="main">
<v-row justify="center" id="card" style="display: block;">
      <v-col>
        <v-card
        id="card1"
        outlined 
        class="white secondary--text pa-8"  
        rounded="xl" 
        align="center"
        elevation="15"    
        >
        <v-row justify="center" id="row1">
        <v-col md=4>
        <v-img 
          src="@/assets/Clean  building rubble.svg"  
          max-height="200"
          max-width="200" 
          contain 
       />
        </v-col>
        <v-col align="start" class="main--text">
        <h2> Clean building rubble </h2>
        <br/>
        <p> Sand, stone, concrete, cement, <br/>
            bricks, and tiles. <br/> 
        </p>
        </v-col>
        </v-row>
        </v-card>
      </v-col>
       <v-col>
        <v-card
        id="card2"
        outlined  
        class=" white secondary--text pa-8"  
        rounded="xl" 
        align="center"
        elevation="15"
        >
        <v-row justify="center" id="row2">
        <v-col md=4>
        <v-img 
          src="@/assets/Recycling.svg" 
          alt="Logo"  
          max-height="200"
          max-width="200"
          contain
       />
        </v-col>
        <v-col align="start" class="main--text">
        <h2> Recycling </h2>
        <br/>
        <p> Glass, paper, cardboard, plastics, metal, and electronics. </p>
        </v-col>
        </v-row>
        </v-card>
      </v-col>
  </v-row>

  <v-row id="card" justify="center" class="mt-4" style="display: block;">
      <v-col>
        <v-card
        id="card3"
        outlined
        class="white secondary--text pa-8"  
        rounded="xl" 
        align="center"
        elevation="15"
        >
        <v-row justify="center" id="row3">
        <v-col md=4>
        <v-img 
          src="@/assets/General waste.svg"  
          max-height="300"
          max-width="300"
          contain
       />
        </v-col>
        <v-col align="start" class="main--text">
        <h2> General waste </h2>
        <br/>
        <p> Commercial, light industrial and <br/>
            domestic waste such as wood, papers,
            plastics, cardboard, metals, and textiles.
        </p>
        </v-col>
        </v-row>
        </v-card>
      </v-col>
       <v-col>
        <v-card
        id="card4"
        outlined  
        class="white secondary--text pa-8"  
        rounded="xl" 
        align="center"
        elevation="15"
        >
        <v-row justify="center" id="row4">
        <v-col md=4>
        <v-img 
          src="@/assets/Plate glass.svg" 
          max-height="200"
          max-width="200"
          contain
       />
        </v-col>
        <v-col align="start" class="main--text">
        <h2> Plate glass </h2>
        <br/>
        <p> Plate glass or sheet glass is a type of glass,
            initially produced in plane form commonly 
            used for windows, glass doors, transparent
            walls, and windscreens.
        </p>
        </v-col>
        </v-row>
        </v-card>
      </v-col>
  </v-row>
  
  <v-row id="card" justify="center" style="display: block;">
      <v-col>
        <v-card
        id="card5"
        outlined  
        class="white secondary--text pa-8"  
        rounded="xl" 
        align="center"
        elevation="15"
        >
        <v-row justify="center" id="row5">
        <v-col md=4>
        <v-img 
          src="@/assets/Garden refuse.svg" 
          max-height="200"
          max-width="200"
          contain
       />
        </v-col>
        <v-col align="start" class="main--text">
        <h2> Garden refuse </h2>
        <br/>
        <p> Branches, grass, leaves, and stumps. </p>
        </v-col>
        </v-row>
        </v-card>
      </v-col>
       <v-col>
        <v-card
        id="card6" 
        outlined
        class="white secondary--text pa-8"  
        rounded="xl" 
        align="center"
        elevation="15"
        >
        <v-row justify="center" id="row6">
        <v-col md=4>
        <v-img 
          src="@/assets/Liquid waste.svg" 
          max-height="200"
          max-width="200"
          contain
       />
        </v-col>
        <v-col align="start" class="main--text">
        <h3> Liquid waste </h3>
        <br/>
        <p> Sewerage, food, or motor oil.</p>
        </v-col>
        </v-row>
        </v-card>
      </v-col>
  </v-row>
</v-container>
</template>

<script>
export default {
  name: 'wasteType',
}
</script>

<style scoped>

#card1, #card2, #card3, #card4, #card5, #card6{
  border: 1px solid black;
}
</style>